import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Tabs, Button, Form, Select, Space, message, Radio } from 'antd';
import constants from '../../../constants/constants';
import { fetchAdminApi } from '../../../services/api';

const { Option } = Select;

const GroupSessionDashboard = () => {
	const history = useHistory();
	const [form] = Form.useForm();
	const [clientList, setClientList] = useState([]);
	const [type, setType] = useState('add');
	const [mappedClients, setMappedClients] = useState([]);
	const [loadingClients, setLoadingClients] = useState(false);

	const onClickCard = (group) => {
		history.push('/group-progress-notes', { preselectedSession: group });
	};

	const useResponsiveTabs = () => {
		const [tabSize, setTabSize] = useState(getTabSize());

		function getTabSize() {
			return window.innerWidth < 768 ? 'small' : 'large';
		}

		useEffect(() => {
			const handleResize = () => setTabSize(getTabSize());

			window.addEventListener('resize', handleResize);
			return () => window.removeEventListener('resize', handleResize);
		}, []);

		return tabSize;
	};
	useEffect(() => {
	  getClientList();
	}, [])
	

	const tabSize = useResponsiveTabs();

	const renderGroupCards = (ids) => {
		const filteredGroups = constants.GroupSessionList.filter(group => ids.includes(group.value));
		return (
			<Row gutter={[24, 24]}>
				{filteredGroups.map(group => (
					<Col xs={24} sm={12} lg={6} key={group.value}>
						<Card
							styles={{ body: { height: "100%" } }}
							size="small"
							className="bg-amber-300 text-slate-800 text-center h-36 cursor-pointer hover:shadow-lg hover:scale-[1.02] transition-transform duration-200"
							onClick={() => onClickCard(group)}
						>
							<div className="h-full grid place-content-center gap-3">
								<span className="text-base font-bold">{group.label}</span>
							</div>
						</Card>
					</Col>
				))}
			</Row>
		);
	};

	const getClientList = () => {
		let payload = {
			type:"1,3",
			flag: "1",
			sort_column: "name",
			sort_type: "asc"
		}
		fetchAdminApi(`/dashboard`, "post", payload).then((res) => {
			if (res && res.data) {
				setClientList(res.data);
			}
			else {
				setClientList([]);
			}
		});
	};

	const onFinish = (values) => {
		let payload = values;
		if (type === 'add') {
			fetchAdminApi(`/save-group-notes`, "post", payload)
			.then((res) => {
				if (res?.code === 200) {
				form.resetFields();
				message.success(res?.message);
				} else {
				message.error(res?.message);
				}
			})
			.catch(() => message.error("Something went wrong"));
		} else if (type === 'remove') {
			fetchAdminApi(`/delete-grp-note-user`, "post", payload)
			.then((res) => {
				if (res?.code === 200) {
				form.resetFields();
				message.success(res?.message);
				} else {
				message.error(res?.message);
				}
			})
			.catch(() => message.error("Something went wrong"));
		}
	};


	const handleGroupSessionChange = async (group_session_id) => {
		if (type !== 'remove' || !group_session_id) return;
		const payload = {
			group_session_id: group_session_id,
		};
		try {
			setLoadingClients(true);
			const res = await fetchAdminApi(`/get-group-client`, "post", payload);
			if (res?.code === 200) {
			setMappedClients(res?.data || []);
			} else {
			message.error(res?.message);
			setMappedClients([]);
			}
		} catch (error) {
			console.error(error);
			message.error("Something went wrong");
			setMappedClients([]);
		} finally {
			setLoadingClients(false);
		}
	};



	const generalFormsContent = () => {
		return (
		<Form
			form={form}
			onFinish={onFinish}
			// onFinishFailed={onFinishFailed}
			autoComplete="off"
		>
			<Form.Item
				className="mb-3"
				rules={[
					{ required: true },
				]}
			>
				<Radio.Group
					onChange={(e) => {
						setType(e.target.value);
						form.setFieldsValue({
						group_session: undefined,
						user: [],
						});
						setMappedClients([]);
					}}
					defaultValue={'add'}
					value={type}
				>
				<Radio value="add">ADD</Radio>
				<Radio value="remove">REMOVE</Radio>
				</Radio.Group>

			</Form.Item>
			<Form.Item
				label={constants.GroupSession}
				name="group_session"
				rules={[{ required: true, message: "Select Group Session" }]}
				className="w-1/2"
				>
				<Select
					placeholder={constants.GroupSession}
					allowClear
					showSearch
					onChange={handleGroupSessionChange}
					filterOption={(input, option) =>
					option?.children?.props?.children
						?.toLowerCase()
						?.includes(input.toLowerCase())
					}
				>
					{constants.GroupSessionList.map(({ value, label }) => (
					<Option key={value} value={value}>
						<div className="whitespace-normal">{label}</div>
					</Option>
					))}
				</Select>
			</Form.Item>

			<Form.Item
				label="Client/Enquiry"
				name="user"
				className="w-1/2"
				rules={[{ required: true, message: "Select Client/Enquiry" }]}
				>
				<Select
					placeholder="Client/Enquiry"
					allowClear
					showSearch
					mode="multiple"
					loading={loadingClients}
					filterOption={(input, option) =>
					option?.children?.props?.children
						?.toLowerCase()
						?.includes(input.toLowerCase())
					}
				>
					{(type === 'remove' ? mappedClients : clientList)?.map((value) => (
					<Option key={value.client_id} value={value.client_id}>
						{type === 'remove' ? value.client_name : value.name}
					</Option>
					))}
				</Select>
			</Form.Item>

			<Form.Item>
				<Space className="float-left">
					<Button className='bg-sky-800 text-white uppercase' type='primary' onClick={() => history.goBack()}>
						{constants.Cancel}
					</Button>
					<Button className='bg-sky-800 text-white uppercase' type='primary' htmlType="submit">
						{type === 'remove' ?  constants.Remove : constants.Save}
					</Button>
				</Space>
			</Form.Item>
		</Form>
		)
	}
	const generalTab = {
		label: "Add/Remove Group",
		key: "general",
		children: generalFormsContent(),
	};

	const tabItems = Object.entries(constants.GroupSessionCategories).map(([category, ids]) => ({
		label: category,
		key: category,
		children: renderGroupCards(ids),
	})).concat(generalTab);

	return (
		<div>
			<div className="text-center bg-amber-300 text-lg font-semibold p-3">{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl capitalize">{constants.GroupSession} Dashboard</span>
			</div>
			{history.length > 1 && <div className='bg-amber-100 text-base font-semibold p-1.5 mb-3'><div className="container mx-auto">
				<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={() => history.goBack()}>{constants.BackBtn}</Button>
			</div></div>}

			<div className="container mx-auto">
				<div className="mx-6 sm:mx-0 mt-6 mb-6">
					<Tabs tabPosition="top" size={tabSize} defaultActiveKey="Family Group" items={tabItems}
					/>
				</div>
			</div>
		</div>
	);
};

export default GroupSessionDashboard;
